import React from "react";

const CardClient = () => {
    return (
        <div className="container-card-client">
            <span className="client-data">Guillermo Benítez Núñez</span>
            <span className="client-data">1234567</span>
            <span className="client-data">012345678</span>
            <span className="client-data">3</span>
        </div>
    )
};
export default CardClient;